import Button from 'blocks/Button';
import Paths from 'helper/paths';
import { useNavigate } from 'react-router';
import * as S from './statusBox.styles';
import { StatusBoxProps } from './statusbox.interface';

const StatusBox = ({ type, text, textBtn, children, route }: StatusBoxProps) => {
  const navigate = useNavigate();
  return (
    <S.Wrapper>
      <S.Container>
        <S.StatusTitle $type={type}>{text}</S.StatusTitle>
        <S.BtnStatus
          onClick={() => navigate(route ? route : Paths.Main.index().route)}
          as={Button}
          color="text-button"
          width={100}
        >
          {textBtn}
        </S.BtnStatus>
        {children && <S.Statusdesc>{children}</S.Statusdesc>}
      </S.Container>
    </S.Wrapper>
  );
};

export default StatusBox;
